import React from 'react';
import { Form, Select } from 'antd';
import { usePmCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';

interface FormItemProps {
  fieldname: string
  required?: boolean
}

const PmFormItem = ({fieldname, required = false}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
  * hooks
  * ====================================================== */
  const { pmCodeList } = usePmCode();  

  /* ======================================================
  * events
  * ====================================================== */  

  /* ======================================================
  * effects
  * ====================================================== */  

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
        <Form.Item name={fieldname} style={{ width:'180px', display: 'inline-block'}} rules={[{ required: required, message: '' }]}>
          <Select 
            showSearch
            placeholder="PM 선택" 
            allowClear 
            optionFilterProp="label"
            filterOption={selectBoxFilterOption}
            options={pmCodeList} />     
        </Form.Item>
    </>
  );
};

export default PmFormItem;
